import { configureStore } from "@reduxjs/toolkit";

import analyticsReducer from "../features/analytics/analyticsSlice";
import { dashboardState, loginState } from "../reducers/dashboardReducers";

export const buildStore = (preloadedState) =>
  configureStore({
    reducer: {
      analytics: analyticsReducer,
      dashboardState,
      loginState,
    },
    preloadedState: preloadedState,
  });

const store = buildStore();
export default store;
